import React, { Component } from 'react';

class Item extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  onChange = (e) => {
    console.log(e);
  };
  
  render() {
    return (
      <tr>
        <td>234</td>
        <td>
          추가
        </td>
        <td>
          814392
        </td>
        <td>
          송재학
        </td>
        <td>
          Online ISSN 1225-4587
        </td>
        <td>
          KCI 약어 논문명 J ADV PROSTHODONT
        </td>
        <td>
          2021-03-12 14:08:03
        </td>
      </tr>
    )
  }
}

export default Item;